<div class="relative overflow-hidden md:overflow-visible" [class]="isOfferList() ? 'md:h-[50vh]' : 'md:h-[70vh]'">
	<img
		[ngSrc]="heroBannerMobileSrc"
		width="768"
		height="1024"
		priority
		sizes="100vw"
		[alt]="'Baner — ' + hostConfig.siteName()"
		class="absolute inset-0 h-full w-full object-cover md:hidden"
	/>
	<img
		[ngSrc]="heroBannerDesktopSrc"
		width="1920"
		height="800"
		priority
		sizes="100vw"
		[alt]="'Baner — ' + hostConfig.siteName()"
		class="absolute inset-0 hidden h-full w-full object-cover md:block"
	/>
	<div
		class="relative z-10 flex flex-col items-stretch justify-start p-3 md:absolute md:inset-0 md:items-center md:justify-center md:px-8 md:py-10 gap-6 md:gap-8"
	>
		@if (!isOfferList()) {
			<h1
				class="hidden md:block text-white text-center font-bold text-3xl md:text-5xl max-w-5xl drop-shadow-[0_2px_8px_rgba(0,0,0,0.35)]"
			>
				Znajdź swoje wymarzone wakacje z Biurem Podróży Oskar
			</h1>
		}

		<app-new-top-search class="w-full" [isOfferList]="isOfferList()"></app-new-top-search>
	</div>
	<!-- <app-banner-carousel></app-banner-carousel> -->
</div>
